import _defineProperty from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _slicedToArray from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _classCallCheck from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createClass.js";
var _excluded = ["chars", "padding", "resolution", "textureWidth", "textureHeight"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { utils, ALPHA_MODES, MIPMAP_MODES, Rectangle, Texture, settings, BaseTexture } from '@pixi/core';
import { TextStyle, TextMetrics } from '@pixi/text';
import { autoDetectFormat } from './formats/index.mjs';
import { BitmapFontData } from './BitmapFontData.mjs';
import './utils/index.mjs';
import { resolveCharacters } from './utils/resolveCharacters.mjs';
import { drawGlyph } from './utils/drawGlyph.mjs';
import { extractCharCode } from './utils/extractCharCode.mjs';
var _BitmapFont = /*#__PURE__*/function () {
  function _BitmapFont(data, textures, ownsTextures) {
    var _distanceField$fieldT, _distanceField$fieldT2;
    _classCallCheck(this, _BitmapFont);
    var _data$info = _slicedToArray(data.info, 1),
      info = _data$info[0];
    var _data$common = _slicedToArray(data.common, 1),
      common = _data$common[0];
    var _data$page = _slicedToArray(data.page, 1),
      page = _data$page[0];
    var _data$distanceField = _slicedToArray(data.distanceField, 1),
      distanceField = _data$distanceField[0];
    var res = utils.getResolutionOfUrl(page.file);
    var pageTextures = {};
    this._ownsTextures = ownsTextures;
    this.font = info.face;
    this.size = info.size;
    this.lineHeight = common.lineHeight / res;
    this.chars = {};
    this.pageTextures = pageTextures;
    for (var i = 0; i < data.page.length; i++) {
      var _data$page$i = data.page[i],
        id = _data$page$i.id,
        file = _data$page$i.file;
      pageTextures[id] = textures instanceof Array ? textures[i] : textures[file];
      if (distanceField !== null && distanceField !== void 0 && distanceField.fieldType && distanceField.fieldType !== "none") {
        pageTextures[id].baseTexture.alphaMode = ALPHA_MODES.NO_PREMULTIPLIED_ALPHA;
        pageTextures[id].baseTexture.mipmap = MIPMAP_MODES.OFF;
      }
    }
    for (var _i = 0; _i < data.char.length; _i++) {
      var _data$char$_i = data.char[_i],
        _id = _data$char$_i.id,
        page2 = _data$char$_i.page;
      var _data$char$_i2 = data.char[_i],
        x = _data$char$_i2.x,
        y = _data$char$_i2.y,
        width = _data$char$_i2.width,
        height = _data$char$_i2.height,
        xoffset = _data$char$_i2.xoffset,
        yoffset = _data$char$_i2.yoffset,
        xadvance = _data$char$_i2.xadvance;
      x /= res;
      y /= res;
      width /= res;
      height /= res;
      xoffset /= res;
      yoffset /= res;
      xadvance /= res;
      var rect = new Rectangle(x + pageTextures[page2].frame.x / res, y + pageTextures[page2].frame.y / res, width, height);
      this.chars[_id] = {
        xOffset: xoffset,
        yOffset: yoffset,
        xAdvance: xadvance,
        kerning: {},
        texture: new Texture(pageTextures[page2].baseTexture, rect),
        page: page2
      };
    }
    for (var _i2 = 0; _i2 < data.kerning.length; _i2++) {
      var _data$kerning$_i = data.kerning[_i2],
        first = _data$kerning$_i.first,
        second = _data$kerning$_i.second,
        amount = _data$kerning$_i.amount;
      first /= res;
      second /= res;
      amount /= res;
      if (this.chars[second]) {
        this.chars[second].kerning[first] = amount;
      }
    }
    this.distanceFieldRange = distanceField === null || distanceField === void 0 ? void 0 : distanceField.distanceRange;
    this.distanceFieldType = (_distanceField$fieldT = distanceField === null || distanceField === void 0 ? void 0 : (_distanceField$fieldT2 = distanceField.fieldType) === null || _distanceField$fieldT2 === void 0 ? void 0 : _distanceField$fieldT2.toLowerCase()) !== null && _distanceField$fieldT !== void 0 ? _distanceField$fieldT : "none";
  }
  _createClass(_BitmapFont, [{
    key: "destroy",
    value: function destroy() {
      for (var id in this.chars) {
        this.chars[id].texture.destroy();
        this.chars[id].texture = null;
      }
      for (var _id2 in this.pageTextures) {
        if (this._ownsTextures) {
          this.pageTextures[_id2].destroy(true);
        }
        this.pageTextures[_id2] = null;
      }
      this.chars = null;
      this.pageTextures = null;
    }
  }], [{
    key: "install",
    value: function install(data, textures, ownsTextures) {
      var fontData;
      if (data instanceof BitmapFontData) {
        fontData = data;
      } else {
        var format = autoDetectFormat(data);
        if (!format) {
          throw new Error("Unrecognized data format for font.");
        }
        fontData = format.parse(data);
      }
      if (textures instanceof Texture) {
        textures = [textures];
      }
      var font = new _BitmapFont(fontData, textures, ownsTextures);
      _BitmapFont.available[font.font] = font;
      return font;
    }
  }, {
    key: "uninstall",
    value: function uninstall(name) {
      var font = _BitmapFont.available[name];
      if (!font) {
        throw new Error("No font found named '".concat(name, "'"));
      }
      font.destroy();
      delete _BitmapFont.available[name];
    }
  }, {
    key: "from",
    value: function from(name, textStyle, options) {
      if (!name) {
        throw new Error("[BitmapFont] Property `name` is required.");
      }
      var _Object$assign = Object.assign({}, _BitmapFont.defaultOptions, options),
        chars = _Object$assign.chars,
        padding = _Object$assign.padding,
        resolution = _Object$assign.resolution,
        textureWidth = _Object$assign.textureWidth,
        textureHeight = _Object$assign.textureHeight,
        baseOptions = _objectWithoutProperties(_Object$assign, _excluded);
      var charsList = resolveCharacters(chars);
      var style = textStyle instanceof TextStyle ? textStyle : new TextStyle(textStyle);
      var lineWidth = textureWidth;
      var fontData = new BitmapFontData();
      fontData.info[0] = {
        face: style.fontFamily,
        size: style.fontSize
      };
      fontData.common[0] = {
        lineHeight: style.fontSize
      };
      var positionX = 0;
      var positionY = 0;
      var canvas;
      var context;
      var baseTexture;
      var maxCharHeight = 0;
      var baseTextures = [];
      var textures = [];
      for (var i = 0; i < charsList.length; i++) {
        if (!canvas) {
          canvas = settings.ADAPTER.createCanvas();
          canvas.width = textureWidth;
          canvas.height = textureHeight;
          context = canvas.getContext("2d");
          baseTexture = new BaseTexture(canvas, _objectSpread({
            resolution: resolution
          }, baseOptions));
          baseTextures.push(baseTexture);
          textures.push(new Texture(baseTexture));
          fontData.page.push({
            id: textures.length - 1,
            file: ""
          });
        }
        var character = charsList[i];
        var metrics = TextMetrics.measureText(character, style, false, canvas);
        var width = metrics.width;
        var height = Math.ceil(metrics.height);
        var textureGlyphWidth = Math.ceil((style.fontStyle === "italic" ? 2 : 1) * width);
        if (positionY >= textureHeight - height * resolution) {
          if (positionY === 0) {
            throw new Error("[BitmapFont] textureHeight ".concat(textureHeight, "px is too small (fontFamily: '").concat(style.fontFamily, "', fontSize: ").concat(style.fontSize, "px, char: '").concat(character, "')"));
          }
          --i;
          canvas = null;
          context = null;
          baseTexture = null;
          positionY = 0;
          positionX = 0;
          maxCharHeight = 0;
          continue;
        }
        maxCharHeight = Math.max(height + metrics.fontProperties.descent, maxCharHeight);
        if (textureGlyphWidth * resolution + positionX >= lineWidth) {
          if (positionX === 0) {
            throw new Error("[BitmapFont] textureWidth ".concat(textureWidth, "px is too small (fontFamily: '").concat(style.fontFamily, "', fontSize: ").concat(style.fontSize, "px, char: '").concat(character, "')"));
          }
          --i;
          positionY += maxCharHeight * resolution;
          positionY = Math.ceil(positionY);
          positionX = 0;
          maxCharHeight = 0;
          continue;
        }
        drawGlyph(canvas, context, metrics, positionX, positionY, resolution, style);
        var id = extractCharCode(metrics.text);
        fontData.char.push({
          id: id,
          page: textures.length - 1,
          x: positionX / resolution,
          y: positionY / resolution,
          width: textureGlyphWidth,
          height: height,
          xoffset: 0,
          yoffset: 0,
          xadvance: Math.ceil(width - (style.dropShadow ? style.dropShadowDistance : 0) - (style.stroke ? style.strokeThickness : 0))
        });
        positionX += (textureGlyphWidth + 2 * padding) * resolution;
        positionX = Math.ceil(positionX);
      }
      for (var _i3 = 0, len = charsList.length; _i3 < len; _i3++) {
        var first = charsList[_i3];
        for (var j = 0; j < len; j++) {
          var second = charsList[j];
          var c1 = context.measureText(first).width;
          var c2 = context.measureText(second).width;
          var total = context.measureText(first + second).width;
          var amount = total - (c1 + c2);
          if (amount) {
            fontData.kerning.push({
              first: extractCharCode(first),
              second: extractCharCode(second),
              amount: amount
            });
          }
        }
      }
      var font = new _BitmapFont(fontData, textures, true);
      if (_BitmapFont.available[name] !== void 0) {
        _BitmapFont.uninstall(name);
      }
      _BitmapFont.available[name] = font;
      return font;
    }
  }]);
  return _BitmapFont;
}();
var BitmapFont = _BitmapFont;
BitmapFont.ALPHA = [["a", "z"], ["A", "Z"], " "];
BitmapFont.NUMERIC = [["0", "9"]];
BitmapFont.ALPHANUMERIC = [["a", "z"], ["A", "Z"], ["0", "9"], " "];
BitmapFont.ASCII = [[" ", "~"]];
BitmapFont.defaultOptions = {
  resolution: 1,
  textureWidth: 512,
  textureHeight: 512,
  padding: 4,
  chars: _BitmapFont.ALPHANUMERIC
};
BitmapFont.available = {};
export { BitmapFont };